import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useI18n } from "@/shared/hooks";
import { Section, Title } from "@/components/UI";
import { useTestId } from "@/hooks";
import { useRefsContext } from "@/contexts/ref";
import { PartnerBoxAds } from "@/components/Sections/Price/PartnerBoxAds";
import { PriceComponents } from "@/components/Sections/Price/PriceComponents";
import { usePriceComponents } from "@/components/Sections/Price";
import { useBrandContext } from "@/shared/contexts";
import { PARTNER_NAME } from "@/shared/types";
export const Price = () => {
    const testId = useTestId("Sections.Price");
    const { t } = useI18n();
    const components = usePriceComponents();
    const { priceRef } = useRefsContext();
    const modalPartner = useBrandContext().partnerService.find((service) => service.name === PARTNER_NAME.KFW);
    return (components === null || components === void 0 ? void 0 : components.length) ? (_jsxs(Section, { ref: priceRef, hasDivider: true, testId: testId, children: [_jsx(Title, { variant: "section", title: t("price.title"), id: "price" }), _jsx(PriceComponents, {}), _jsx(PartnerBoxAds, { partner: modalPartner })] })) : null;
};
